




















import Vue from 'vue'

import { WEARABLE_PRODUCTS_ID } from '@/product/const'

export default Vue.extend({
  data(): {
    isWearableProduct: boolean
  } {
    return {
      isWearableProduct: false
    }
  },
  created() {
    const { id } = this.$route.params
    this.isWearableProduct = WEARABLE_PRODUCTS_ID.indexOf(parseInt(id)) > -1
  }
})
